import React from "react";
import { ArrowUpRight } from "lucide-react";
import { organizations } from "../mock";

const Organizations = () => {
  const featured = organizations.find((o) => o.featured);
  const rest = organizations.filter((o) => !o.featured);

  return (
    <section id="platform" className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="max-w-3xl">
          <div className="text-xs uppercase tracking-[0.18em] text-teal-700 font-medium">
            Built for the body of believers
          </div>
          <h2 className="mt-4 text-4xl md:text-5xl lg:text-6xl font-semibold tracking-tight text-black leading-[1.05]">
            From small parishes to{" "}
            <em className="text-teal-700 font-serif font-normal">
              Kingdom-minded founders.
            </em>
          </h2>
          <p className="mt-5 text-lg text-black/60 max-w-2xl">
            One platform for the communities, leaders, and entrepreneurs God is
            calling to bear good fruit — in their churches, their work, and
            their finances.
          </p>
        </div>

        <div className="mt-14 space-y-6 md:space-y-8">
          {/* Featured */}
          {featured && (
            <article className="group relative overflow-hidden rounded-2xl border border-black/10 bg-white transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_20px_60px_-20px_rgba(0,0,0,0.25)]">
              <div className="flex flex-col md:flex-row">
                <div className="relative overflow-hidden bg-black md:w-1/2 h-72 md:h-auto md:min-h-[380px]">
                  <img
                    src={featured.image}
                    alt={featured.title}
                    loading="lazy"
                    className="w-full h-full object-cover opacity-90 group-hover:scale-105 group-hover:opacity-100 transition-transform duration-700"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent" />
                  <span className="absolute top-4 left-4 bg-teal-400 text-black text-[11px] font-semibold px-3 py-1 rounded-full tracking-wide uppercase">
                    Featured · Faith
                  </span>
                </div>
                <div className="p-7 md:p-10 flex flex-col justify-center md:w-1/2">
                  <h3 className="text-2xl md:text-3xl font-semibold tracking-tight text-black">
                    {featured.title}
                  </h3>
                  <div className="mt-2 text-teal-700 font-medium">
                    {featured.tagline}
                  </div>
                  <p className="mt-4 text-black/65 leading-relaxed">
                    {featured.description}
                  </p>
                  <button className="mt-6 inline-flex items-center gap-1.5 text-black font-semibold w-fit border-b border-black/30 pb-0.5 hover:border-teal-600 hover:text-teal-700 transition-colors">
                    {featured.cta}
                    <ArrowUpRight className="w-4 h-4" />
                  </button>
                </div>
              </div>
            </article>
          )}

          {/* Remaining */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
            {rest.map((org) => (
              <article
                key={org.id}
                className="group relative overflow-hidden rounded-2xl border border-black/10 bg-white transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_20px_60px_-20px_rgba(0,0,0,0.25)]"
              >
                <div className="relative h-56 overflow-hidden bg-black">
                  <img
                    src={org.image}
                    alt={org.title}
                    loading="lazy"
                    className="w-full h-full object-cover opacity-90 group-hover:scale-105 group-hover:opacity-100 transition-transform duration-700"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent" />
                </div>
                <div className="p-7">
                  <h3 className="text-xl font-semibold tracking-tight text-black">
                    {org.title}
                  </h3>
                  <div className="mt-1.5 text-teal-700 font-medium text-sm">
                    {org.tagline}
                  </div>
                  <p className="mt-3 text-black/60 text-sm leading-relaxed">
                    {org.description}
                  </p>
                  <button className="mt-5 inline-flex items-center gap-1.5 text-black font-semibold w-fit border-b border-black/30 pb-0.5 hover:border-teal-600 hover:text-teal-700 transition-colors text-sm">
                    {org.cta}
                    <ArrowUpRight className="w-4 h-4" />
                  </button>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Organizations;
